import axios from "axios";
import globals from "@/config/globals";
import qs from "qs";

export default {
  index() {
    return axios.get(`${globals.getApiHost()}/commissions-plans`);
  },
}
